module.exports = __webpack_public_path__ + "static/abutz-20241003-DSC_9876-2-3824b986d1d455b23b11399f9c32f1ce.jpg";